import {NgModule, ModuleWithProviders} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {InputComponent} from './input/input.component';
import {RadioComponent} from './radio/radio.component';
import {RatingComponent} from './rating/rating.component';
import {CardVendedorComponent } from './card-vendedor/card-vendedor.component';

import { UploadImagemComponent } from './upload-imagem/upload-imagem.component';
import { NumberModule } from '../pipes/number.module';


@NgModule({
    declarations: [InputComponent, 
                   RadioComponent,
                   RatingComponent,
                   UploadImagemComponent,
                   CardVendedorComponent],
    imports: [CommonModule, FormsModule, ReactiveFormsModule, NumberModule],
    exports: [InputComponent, RadioComponent, RatingComponent, 
              CommonModule, FormsModule, ReactiveFormsModule,
              CardVendedorComponent]
})
export class SharedModule {

    static forRoot(): ModuleWithProviders {
        return {
            ngModule: SharedModule,
            providers: [
            ]
        }
    }

}


// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts